export const articles = [
  {
    slug: 'ruhe-tisheng-qinmi-zhiliang',
    title: '如何提升亲密关系质量：从日常小事开始的五个方法',
    excerpt: '高质量的亲密关系并非一蹴而就，而是由无数个日常小细节堆砌而成。本文分享五个简单实用的方法，帮助你和伴侣在日常中建立更深层的连接。',
    content: `<p>在快节奏的现代生活中，很多伴侣发现彼此之间的亲密感正在逐渐流失。工作压力、生活琐事、育儿责任……种种因素让两个人越来越像"室友"而非"爱人"。然而，高质量的亲密关系并非遥不可及的奢望，它往往隐藏在日常的细微之处。</p>

<h2>一、每日十分钟的专注对话</h2>
<p>每天抽出十分钟，放下手机、关掉电视，与伴侣进行一场没有任何干扰的对话。重点不在于谈论什么，而在于"在场"——让对方感受到你此时此刻的全部注意力都在ta身上。这种专注的陪伴，是建立情感连接最基础也最有效的方式。</p>
<p>研究表明，持续进行专注对话的伴侣，其关系满意度比普通伴侣高出37%。这是因为专注的倾听会让对方感受到被看见、被理解的价值感。</p>

<h2>二、身体接触的力量</h2>
<p>非性行为的身体接触——牵手、拥抱、轻抚后背——能够释放催产素，这种被称为"爱的荷尔蒙"的物质能有效降低压力水平、增强信任感。每天至少进行三次有意识的身体接触，每次持续20秒以上，让身体记住爱的温度。</p>

<h2>三、学会表达感激</h2>
<p>我们往往对伴侣的付出习以为常，却很少主动表达感谢。试着每天找出一件伴侣为你做的小事，真诚地说一声"谢谢"。这种正向反馈不仅能让对方感到被认可，也会让你自己更加关注关系中的积极面。</p>

<h2>四、共同创造"我们"的时间</h2>
<p>无论是每周一次的电影之夜，还是每月一次的短途旅行，固定的"二人时光"能让关系保持新鲜感。关键在于这段时间只属于你们两个人，没有孩子、没有工作、没有外界干扰。</p>

<h2>五、学会健康地处理冲突</h2>
<p>冲突在任何关系中都是不可避免的，关键在于如何处理。避免指责性语言，使用"我感到……"代替"你总是……"；在情绪激动时约定暂停机制；记住你们是并肩解决问题的队友，而非对立面的敌人。</p>
<p>亲密关系的质量决定了生活的幸福感。从今天开始，选择其中一个小方法，用心经营你的关系，你会发现改变正在悄然发生。</p>`,
    category: 'qinggan-lianjie',
    image: 'https://readdy.ai/api/search-image?query=Warm%20intimate%20couple%20sitting%20on%20sofa%20having%20deep%20conversation%2C%20soft%20natural%20light%20through%20window%2C%20cozy%20living%20room%20with%20warm%20beige%20tones%2C%20emotional%20connection%2C%20editorial%20photography%20style%2C%20gentle%20atmosphere%2C%20tender%20moment&width=800&height=500&seq=article-qinmi-01&orientation=landscape',
    author: '林悦心',
    authorTitle: '注册心理咨询师',
    readTime: 8,
    publishedAt: '2026-07-28',
    featured: true,
    tags: ['亲密关系', '情感连接', '伴侣沟通', '关系经营'],
  },
  {
    slug: 'xingjiankang-changjian-wenti',
    title: '性健康常见问题解答：打破误区，建立科学认知',
    excerpt: '关于性健康，社会上流传着许多误解和迷思。本文邀请专业医师，针对最常见的十个性健康问题进行科学解答，帮助你建立正确的认知。',
    content: `<p>性健康是整体健康的重要组成部分，然而由于文化和社会因素，许多人对此知之甚少，甚至存在大量误解。本文整理了临床上最常见的性健康问题，并邀请专业医师进行科学解答。</p>

<h2>一、什么是正常的性欲水平？</h2>
<p>性欲没有统一的标准，每个人的性欲水平都受到生理、心理、环境等多重因素影响。只要不影响正常生活和伴侣关系，任何水平的性欲都是正常的。重要的是伴侣之间的沟通和理解，而非追求某种"标准"。</p>

<h2>二、年龄增长必然导致性功能下降吗？</h2>
<p>随着年龄增长，身体确实会发生一些变化，但这并不意味着性生活质量必然下降。许多中老年伴侣通过调整方式、加强沟通，反而获得了更加和谐的性生活。关键在于保持健康的生活方式和积极的心态。</p>

<h2>三、性传播疾病的预防措施</h2>
<p>定期进行性健康检查、正确使用安全套、保持固定的性伴侣是预防性传播疾病的基本原则。此外，HPV疫苗的接种也是重要的预防手段之一。</p>

<h2>四、女性性健康需要关注的信号</h2>
<p>月经周期的异常变化、不明原因的盆腔疼痛、性交疼痛等都是需要引起重视的信号。建议每年进行一次妇科检查，及时发现和处理潜在问题。</p>

<h2>五、男性性健康常见误区</h2>
<p>勃起功能障碍（ED）并非只是"心理问题"，很多时候与心血管健康密切相关。如果持续出现ED症状，建议首先进行全面的身体检查，而非自行服用保健品。</p>
<p>建立科学的性健康认知，是保障自身和伴侣健康的第一步。如有具体健康问题，请务必咨询专业医师。</p>`,
    category: 'xingjiankang-zhishi',
    image: 'https://readdy.ai/api/search-image?query=Clean%20modern%20medical%20consultation%20room%20with%20warm%20lighting%2C%20professional%20doctor%20and%20patient%20having%20respectful%20conversation%2C%20soft%20beige%20and%20sage%20green%20interior%2C%20professional%20yet%20warm%20atmosphere%2C%20editorial%20healthcare%20photography&width=800&height=500&seq=article-jiankang-02&orientation=landscape',
    author: '陈思远',
    authorTitle: '三甲医院泌尿外科主任医师',
    readTime: 10,
    publishedAt: '2026-07-25',
    featured: true,
    tags: ['性健康', '医学知识', '健康科普', '两性健康'],
  },
  {
    slug: 'hunyin-xingfu-mijue',
    title: '婚姻幸福的七个秘诀：来自二十年婚姻咨询师的建议',
    excerpt: '婚姻是一场漫长的旅程，需要智慧和耐心。资深婚姻咨询师总结出七个维系幸福婚姻的关键要素，帮助无数伴侣走出困境，重拾爱的温度。',
    content: `<p>从事婚姻咨询二十年，我见证了无数伴侣从陌生到熟悉、从甜蜜到疏离、又从危机中重生的全过程。幸福的婚姻并非没有矛盾，而是在于如何应对矛盾。以下是我总结的七个关键要素。</p>

<h2>一、保持平等的伴侣关系</h2>
<p>健康的婚姻建立在平等的基础上。无论是经济决策、家务分工还是子女教育，双方都应享有平等的话语权。当一方长期处于弱势地位，积累的不满终将爆发。</p>

<h2>二、建立有效的沟通机制</h2>
<p>许多婚姻问题的根源在于沟通不畅。学会倾听、学会表达、学会在冲突中保持尊重——这些看似简单的技能，却是婚姻长久的基石。</p>

<h2>三、维护彼此的独立性</h2>
<p>婚姻是两个独立个体的结合，而非融合。保留各自的兴趣爱好、社交圈子和独处时间，反而能让两个人在一起时更加珍惜彼此。</p>

<h2>四、共同成长而非相互消耗</h2>
<p>最好的婚姻状态是两个人都在关系中变得更好。支持伴侣的个人发展，同时也不放弃自我成长，让婚姻成为彼此成长的土壤。</p>

<h2>五、培养共同的愿景</h2>
<p>无论是对未来的规划还是对生活方式的选择，拥有共同的目标能让伴侣在面对困难时更加团结。定期交流彼此的期望和计划，确保你们还在同一条路上。</p>

<h2>六、保持亲密感</h2>
<p>亲密感不仅仅指性，更包括情感上的亲密。分享内心的脆弱、诉说真实的感受、在对方需要时给予支持——这些都是维系亲密感的重要方式。</p>

<h2>七、学会原谅和放下</h2>
<p>每个人都有犯错的时候。学会真诚地道歉，也学会真心地原谅。不要翻旧账，不要让过去的伤害持续影响当下的关系。</p>`,
    category: 'hunyin-jingying',
    image: 'https://readdy.ai/api/search-image?query=Mature%20couple%20walking%20hand%20in%20hand%20in%20beautiful%20autumn%20park%2C%20golden%20warm%20sunset%20light%2C%20peaceful%20and%20content%20expressions%2C%20long%20term%20relationship%20happiness%2C%20editorial%20lifestyle%20photography%2C%20warm%20earthy%20tones&width=800&height=500&seq=article-hunyin-03&orientation=landscape',
    author: '王雅文',
    authorTitle: '资深婚姻家庭咨询师',
    readTime: 12,
    publishedAt: '2026-07-22',
    featured: true,
    tags: ['婚姻幸福', '夫妻关系', '婚姻经营', '家庭和谐'],
  },
  {
    slug: 'chongtu-goutong-jiqiao',
    title: '伴侣冲突时如何有效沟通？这些技巧让吵架变成增进感情的机会',
    excerpt: '冲突并不可怕，可怕的是不会处理冲突。学会正确的冲突沟通技巧，让每一次分歧都成为关系成长的契机。',
    content: `<p>再恩爱的伴侣也会有意见不合的时候。事实上，从不吵架的伴侣未必幸福，而经常吵架的伴侣也未必不幸。区别在于——你们如何吵架。</p>

<h2>避免"四大杀手"</h2>
<p>心理学家约翰·戈特曼提出了破坏关系的"四大杀手"：批评、蔑视、防御和冷战。批评针对的是人而非行为（"你总是这么懒"）；蔑视则是在批评之上加上优越感（翻白眼、嘲讽）；防御是将责任推回给对方；冷战则是完全关闭沟通。识别并避免这四种行为，是健康冲突的第一步。</p>

<h2>使用"我陈述"代替"你陈述"</h2>
<p>"你从来不听我说话"和"当我在说话时被打断，我感到不被重视"，这两句话传递的信息截然不同。前者是指责，后者是表达感受。使用以"我"开头的陈述，能让对方更容易接受你的观点。</p>

<h2>设立"暂停"信号</h2>
<p>当情绪过于激动时，约定一个暂停信号（可以是一个词、一个手势），给彼此15-20分钟冷静的时间。但一定要约定回来继续讨论的时间，而非逃避问题。</p>

<h2>聚焦当下，不翻旧账</h2>
<p>一次只解决一个问题。把五年前的事情翻出来只会让冲突升级。如果确实有未解决的问题，约定另外的时间专门讨论。</p>

<h2>以修复为目标</h2>
<p>冲突的最终目标不是"赢"，而是修复关系。即使在最激烈的争吵中，也要让对方知道你还在乎这段关系。一个拥抱、一句"我还是爱你的"，比任何道理都更有力量。</p>`,
    category: 'liangxing-goutong',
    image: 'https://readdy.ai/api/search-image?query=Two%20people%20sitting%20facing%20each%20other%20having%20calm%20conversation%20in%20minimalist%20living%20room%2C%20soft%20diffused%20natural%20light%2C%20body%20language%20showing%20active%20listening%2C%20warm%20neutral%20interior%2C%20editorial%20photography%2C%20peaceful%20resolution%20atmosphere&width=800&height=500&seq=article-goutong-04&orientation=landscape',
    author: '林悦心',
    authorTitle: '注册心理咨询师',
    readTime: 7,
    publishedAt: '2026-07-20',
    featured: false,
    tags: ['两性沟通', '冲突处理', '沟通技巧', '关系修复'],
  },
  {
    slug: 'yalijiechu-xinli-jiankang',
    title: '亲密关系中的压力管理：别让工作压力毁了你们的感情',
    excerpt: '现代人的生活节奏越来越快，工作压力常常成为影响亲密关系的隐形杀手。学会在压力中守护爱情，是每一对伴侣的必修课。',
    content: `<p>你有没有发现，当工作压力大的时候，你对伴侣的耐心会明显下降？这并非你不够爱对方，而是压力正在消耗你的情绪资源。本文探讨如何在高压生活中保护亲密关系。</p>

<h2>理解压力的连锁反应</h2>
<p>长期处于高压状态会让人变得易怒、退缩或过度依赖，这些反应都会直接影响到最亲近的人。第一步是认识到：问题不在于伴侣，而在于压力本身。不要将工作中的负面情绪带回家，也不要将伴侣当作情绪的出口。</p>

<h2>建立"压力防火墙"</h2>
<p>在下班回家之前，给自己一个过渡仪式：可以是听一首喜欢的歌、做几次深呼吸、或者在小区里走一圈。这15分钟的"缓冲时间"能有效帮你切换状态，以更好的面貌面对伴侣。</p>

<h2>分享而非转移</h2>
<p>告诉伴侣你今天过得很累是可以的，但不要将ta当作情绪垃圾桶。学会区分"分享"和"转移"——分享是让对方了解你的状态，转移是将负面情绪发泄给对方。</p>

<h2>共同创造减压活动</h2>
<p>找到一些两个人可以一起做的减压活动：散步、泡澡、按摩、或者只是窝在一起看一部轻松的电影。这些时刻不仅是减压，也是加深情感连接的机会。</p>

<h2>必要时寻求专业帮助</h2>
<p>如果压力已经严重影响到生活质量和关系，不要犹豫寻求心理咨询师的帮助。这不是软弱的表现，而是对自己和关系负责的体现。</p>`,
    category: 'xinli-jiankang',
    image: 'https://readdy.ai/api/search-image?query=Couple%20practicing%20meditation%20together%20in%20serene%20minimalist%20room%2C%20soft%20morning%20light%20streaming%20through%20large%20windows%2C%20calm%20and%20peaceful%20expressions%2C%20wellness%20and%20mental%20health%2C%20editorial%20lifestyle%20photography%2C%20warm%20neutral%20aesthetic&width=800&height=500&seq=article-yali-05&orientation=landscape',
    author: '张明辉',
    authorTitle: '临床心理学家',
    readTime: 9,
    publishedAt: '2026-07-18',
    featured: false,
    tags: ['压力管理', '心理健康', '情绪调节', '伴侣支持'],
  },
  {
    slug: 'haizi-yingxiang-fuqi-ganqing',
    title: '有了孩子之后，如何不让亲子关系影响夫妻感情？',
    excerpt: '孩子是爱情的结晶，但也可能成为夫妻感情的"第三者"。如何在育儿的同时维护好伴侣关系，是每对父母都需要面对的课题。',
    content: `<p>很多夫妻在孩子出生后，会经历一段关系"降温期"。所有的注意力和精力都投向孩子，伴侣关系退居二线。然而，稳固的夫妻关系恰恰是给孩子最好的礼物。</p>

<h2>重新认识角色转变</h2>
<p>从"伴侣"到"父母"的角色转变是巨大的。承认这种转变带来的挑战，理解彼此在适应过程中的困难，是应对这一切的起点。</p>

<h2>保护"二人世界"</h2>
<p>即使有了孩子，也需要定期安排只有两个人的时间。可以是孩子睡着后的半小时聊天、周末让祖辈帮忙带娃的约会之夜、或者每年一次的短途旅行。这段时间对于维持情感连接至关重要。</p>

<h2>公平分担育儿责任</h2>
<p>育儿不应是一个人的责任。建立明确的家庭分工，让双方都有参与感和责任感。当一方过度承担时，不仅会产生怨气，也会让另一方错失与孩子建立亲密关系的机会。</p>

<h2>不要在孩子面前贬低伴侣</h2>
<p>"看看你爸爸，什么都不管"——这样的话可能在气头上说出，但会在孩子心中种下不安的种子。维护伴侣在孩子面前的形象，就是维护整个家庭的稳定。</p>

<h2>记得你们首先是爱人</h2>
<p>在为人父母之前，你们首先是彼此选择的伴侣。保持这个身份认同，时不时做回"恋爱中的那两个人"，会让整个家庭更加和谐美满。</p>`,
    category: 'qinzi-jiaoyu',
    image: 'https://readdy.ai/api/search-image?query=Happy%20family%20of%20three%20playing%20together%20in%20warm%20sunlit%20living%20room%2C%20parents%20sharing%20loving%20glance%20while%20child%20plays%2C%20cozy%20home%20atmosphere%2C%20soft%20beige%20and%20cream%20tones%2C%20editorial%20family%20photography&width=800&height=500&seq=article-qinzi-06&orientation=landscape',
    author: '王雅文',
    authorTitle: '资深婚姻家庭咨询师',
    readTime: 8,
    publishedAt: '2026-07-15',
    featured: false,
    tags: ['亲子关系', '夫妻感情', '家庭和谐', '育儿'],
  },
  {
    slug: 'shenghuo-langman-xiaojiqiao',
    title: '让日常生活充满浪漫的十个小技巧',
    excerpt: '浪漫不一定要等到特殊节日。在日常生活的缝隙中撒入浪漫的种子，让每一天都值得期待。',
    content: `<p>很多人以为浪漫需要精心策划、大费周章。其实，最打动人心的浪漫往往藏在最平凡的日常之中。以下是十个简单却有效的浪漫小技巧。</p>

<h2>一、手写便条</h2>
<p>在伴侣的包里、午餐盒或镜子前留下一张手写的便条，上面写一句简单的"我爱你"或"今天也要开心"。在这个数字化的时代，手写的温度格外珍贵。</p>

<h2>二、不经意的赞美</h2>
<p>"你今天穿这件衣服很好看"、"你刚才处理问题的方式真聪明"。真诚的赞美不需要特殊的场合，随时随地都可以表达。</p>

<h2>三、记住重要的"小事"</h2>
<p>记住伴侣提到的某个小愿望、某个喜欢的味道、某个想去的地方。在合适的时机实现它，这种"被放在心上"的感觉比任何礼物都珍贵。</p>

<h2>四、创造仪式感</h2>
<p>每周五晚上的烛光晚餐、每月第一天的"新开始"早餐、每季度的"回顾与展望"对话。仪式感让平凡的日子有了特别的意义。</p>

<h2>五、学会制造惊喜</h2>
<p>不一定是贵重的礼物，可以是一束路边买的花、一份ta最爱的甜点、或者一次事先未告知的约会。惊喜的核心在于"我想到了你"。</p>`,
    category: 'qinggan-lianjie',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20candlelit%20dinner%20setting%20at%20home%20with%20fresh%20flowers%20and%20handwritten%20note%2C%20warm%20amber%20lighting%2C%20intimate%20cozy%20atmosphere%2C%20simple%20elegant%20table%20setting%2C%20editorial%20lifestyle%20photography%2C%20soft%20focus&width=800&height=500&seq=article-langman-07&orientation=landscape',
    author: '林悦心',
    authorTitle: '注册心理咨询师',
    readTime: 6,
    publishedAt: '2026-07-12',
    featured: false,
    tags: ['浪漫技巧', '日常生活', '情感表达', '仪式感'],
  },
  {
    slug: 'nanxing-xingjiankang-baojian',
    title: '男性性健康保健指南：从生活习惯到定期检查',
    excerpt: '男性性健康往往被忽视，然而它与整体健康密切相关。本文提供全面的男性性健康保健建议，帮助你从日常生活做起。',
    content: `<p>相比女性，男性往往更少关注自身的性健康问题，也更容易忽视身体发出的警示信号。事实上，男性的性健康状况往往反映了整体健康水平，尤其是心血管系统的健康状况。</p>

<h2>一、均衡饮食与规律运动</h2>
<p>地中海式饮食（富含蔬果、全谷物、鱼类和橄榄油）被证明对性健康有积极影响。每周至少150分钟的中等强度运动不仅能增强体质，还能改善血液循环，对性功能有直接的促进作用。</p>

<h2>二、控制体重与戒烟限酒</h2>
<p>肥胖会显著增加勃起功能障碍的风险。吸烟则会损伤血管，直接影响勃起功能。过量饮酒同样会对性功能产生负面影响。做出这些生活方式的改变，是对性健康最有力的投资。</p>

<h2>三、管理慢性疾病</h2>
<p>糖尿病、高血压、高血脂等慢性疾病都可能影响性功能。积极管理这些疾病，不仅是为了性健康，更是为了整体生活质量的保障。</p>

<h2>四、关注心理健康</h2>
<p>焦虑、抑郁、工作压力等心理因素同样会影响性功能。不要忽视心理健康对性健康的影响，必要时寻求专业心理咨询。</p>

<h2>五、定期体检不可少</h2>
<p>建议40岁以上男性每年进行一次前列腺检查。如果出现持续性的性功能问题，应及时就医，因为很多问题在早期是可逆的。</p>`,
    category: 'xingjiankang-zhishi',
    image: 'https://readdy.ai/api/search-image?query=Man%20jogging%20in%20peaceful%20park%20at%20sunrise%2C%20healthy%20active%20lifestyle%2C%20fresh%20morning%20atmosphere%2C%20clean%20modern%20sportswear%2C%20fitness%20and%20wellness%2C%20editorial%20health%20photography%2C%20warm%20golden%20hour%20light&width=800&height=500&seq=article-nanxing-08&orientation=landscape',
    author: '陈思远',
    authorTitle: '三甲医院泌尿外科主任医师',
    readTime: 7,
    publishedAt: '2026-07-10',
    featured: false,
    tags: ['男性健康', '性保健', '健康生活', '定期检查'],
  },
  {
    slug: 'nuxing-xingjiankang-zizun',
    title: '女性性健康与身体自尊：学会爱自己的身体',
    excerpt: '身体自尊是女性性健康的重要组成部分。本文探讨如何建立积极的身体意象，拥抱自己的独特性，从而享受更健康、更愉悦的亲密关系。',
    content: `<p>社会文化对女性身体的苛刻标准，让很多女性对自己的身体产生了负面评价。这种身体意象的困扰不仅影响心理健康，也直接影响着性生活的质量和满意度。</p>

<h2>理解身体意象的影响</h2>
<p>当女性对自己的身体感到不满意时，往往会在亲密关系中表现得拘谨、回避或焦虑。这种心理状态会抑制性欲、降低性愉悦感，甚至影响与伴侣的情感连接。</p>

<h2>挑战不切实际的审美标准</h2>
<p>媒体和社交媒体上呈现的"完美身材"大多是经过精心修饰的。认识到这一点，学会辨别真实与虚构，是建立健康身体意象的第一步。</p>

<h2>关注身体的功能而非外形</h2>
<p>将注意力从"我的身体看起来怎么样"转移到"我的身体能做到什么"。感激身体带给你的力量、柔韧性和感官体验，而非纠结于它与某种标准的差距。</p>

<h2>练习自我关怀</h2>
<p>每天花几分钟时间，以善意而非批判的态度与自己的身体相处。可以是温柔地涂抹身体乳、做几个让自己舒服的伸展动作、或者只是在镜子前给自己一个微笑。</p>

<h2>与伴侣坦诚沟通</h2>
<p>如果你对身体的不自信影响了亲密关系，不妨与伴侣坦诚分享你的感受。很多时候，伴侣眼中的你远比你自己想象的更有魅力。听到这些肯定，能够帮助你重建自信。</p>`,
    category: 'xingjiankang-zhishi',
    image: 'https://readdy.ai/api/search-image?query=Woman%20practicing%20self%20care%20in%20bright%20serene%20bedroom%2C%20looking%20at%20mirror%20with%20gentle%20smile%2C%20soft%20morning%20light%2C%20body%20positivity%20and%20self%20love%20theme%2C%20editorial%20wellness%20photography%2C%20warm%20cream%20and%20blush%20tones&width=800&height=500&seq=article-nvxing-09&orientation=landscape',
    author: '苏婉清',
    authorTitle: '女性健康顾问',
    readTime: 8,
    publishedAt: '2026-07-08',
    featured: false,
    tags: ['女性健康', '身体自尊', '自我关怀', '心理健康'],
  },
];

export const getArticleBySlug = (slug: string) => {
  return articles.find((a) => a.slug === slug) || null;
};

export const getArticlesByCategory = (categorySlug: string) => {
  return articles.filter((a) => a.category === categorySlug);
};

export const getFeaturedArticles = () => {
  return articles.filter((a) => a.featured);
};